import { useTranslation } from "react-i18next";
import { Button } from "@qivia/ui";
import { Page } from "../../components/Page";
import { VehicleConditionForm } from "../shared/vehicleConditionForm";
import "../../../i18n/i18n";

interface VehicleRestitutionConditionStepProps {
  isCabinCleaned: boolean;
  setIsCabinCleaned: (value: boolean) => void;
  isTrunkCleaned: boolean;
  setIsTrunkCleaned: (value: boolean) => void;
  observations: string;
  setObservations: (value: string) => void;
  photos: File[];
  setPhotos: (files: File[]) => void;
  onReturn: () => void;
  onValidate: () => void;
}

export const VehicleRestitutionConditionStep = (
  props: VehicleRestitutionConditionStepProps,
) => {
  const { t } = useTranslation();

  return (
    <Page
      title={t("restitution.vehicleCondition.title")}
      returnButton
      returnButtonAction={props.onReturn}
      helpButton
      withoutHeaderSpacer
      bottomButton={
        <Button
          title={t("restitution.button.validate")}
          onClick={props.onValidate}
          height={3.5}
        />
      }
    >
      <VehicleConditionForm
        isCabinCleaned={props.isCabinCleaned}
        setIsCabinCleaned={props.setIsCabinCleaned}
        isTrunkCleaned={props.isTrunkCleaned}
        setIsTrunkCleaned={props.setIsTrunkCleaned}
        observations={props.observations}
        setObservations={props.setObservations}
        photos={props.photos}
        setPhotos={props.setPhotos}
      />
    </Page>
  );
};
